import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

const ProgressContainer = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${theme.colors.lightGray};
  border-radius: 4px;
  margin: ${theme.spacing.medium} 0;
  overflow: hidden;
`;

const Bar = styled.div<{ progress: number }>`
  height: 100%;
  width: ${props => props.progress}%;
  background-color: ${theme.colors.primary};
  transition: width 0.3s ease-in-out;
`;

const Label = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: ${theme.colors.secondary};
  margin-bottom: ${theme.spacing.small};
`;

interface ProgressBarProps {
  current: number;
  total: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ current, total }) => {
  const percentage = Math.min((current / total) * 100, 100);
  
  return (
    <div>
      <Label>
        <span>Progress</span>
        <span>{Math.round(percentage)}%</span>
      </Label>
      <ProgressContainer>
        <Bar progress={percentage} />
      </ProgressContainer>
    </div>
  );
};

export default ProgressBar;